import messiOtamendi from "./messi-otamendi.png.asset.json";
import wcAustralia from "./wc-australia.jpg.asset.json";
import messiCelebration from "./messi-celebration.jpg.asset.json";
import messiHighfive from "./messi-highfive.jpg.asset.json";
import messiThiago from "./messi-thiago.jpg.asset.json";
import teamHuddle from "./team-huddle.jpg.asset.json";
import teamLineup from "./team-lineup.jpg.asset.json";
import argVsEgypt from "./arg-vs-egypt.png.asset.json";
import argVsJordan from "./arg-vs-jordan.png.asset.json";

export const PHOTOS = {
  messiOtamendi: messiOtamendi.url,
  wcAustralia: wcAustralia.url,
  messiCelebration: messiCelebration.url,
  messiHighfive: messiHighfive.url,
  messiThiago: messiThiago.url,
  teamHuddle: teamHuddle.url,
  teamLineup: teamLineup.url,
  argVsEgypt: argVsEgypt.url,
  argVsJordan: argVsJordan.url,
} as const;

/** Match poster by opponent name (lowercased contains match). */
const MATCH_POSTERS: Array<[string, string]> = [
  ["egypt", PHOTOS.argVsEgypt],
  ["jordan", PHOTOS.argVsJordan],
  ["austria", PHOTOS.wcAustralia],
  ["algeria", PHOTOS.messiCelebration],
];

export function matchPoster(opponent: string | null | undefined): string | null {
  if (!opponent) return null;
  const o = opponent.toLowerCase();
  for (const [key, url] of MATCH_POSTERS) if (o.includes(key)) return url;
  return null;
}

export const PHOTO_ROTATION = [
  PHOTOS.messiOtamendi,
  PHOTOS.messiCelebration,
  PHOTOS.messiHighfive,
  PHOTOS.wcAustralia,
  PHOTOS.messiThiago,
  PHOTOS.teamHuddle,
  PHOTOS.teamLineup,
];

/** Stable image pick from a string id so SSR and client agree. */
export function pickPhoto(seed: string | number) {
  const str = String(seed);
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  return PHOTO_ROTATION[hash % PHOTO_ROTATION.length];
}

/**
 * Single source of truth for the homepage LCP hero image.
 * Used by both the route `head()` preload and the rendered <Img priority>,
 * so the preloaded URL ALWAYS matches what actually paints — even when the
 * featured story changes, the cover image is missing, or data is empty.
 */
export const FEATURED_EGYPT_SLUG = "argentina-egypt-knockout-classic";

export function resolveHomeHeroImage(
  news: Array<{ slug?: string | null; cover_image?: string | null }> | null | undefined,
): string {
  const list = news ?? [];
  const hero = list.find((a) => a?.slug === FEATURED_EGYPT_SLUG) ?? list[0];
  if (hero?.slug === FEATURED_EGYPT_SLUG) {
    return matchPoster("Egypt") ?? hero.cover_image ?? PHOTOS.messiCelebration;
  }
  return hero?.cover_image || PHOTOS.messiCelebration;
}

/**
 * Single source of truth for the article-detail LCP cover image.
 * Mirrors the component fallback (`pickPhoto`) so the preload tag and the
 * rendered <Img> resolve to the exact same URL — no wasted byte, no second
 * LCP candidate.
 */
export function resolveArticleHeroImage(
  article: { id?: string | null; title?: string | null; cover_image?: string | null } | null | undefined,
): string {
  if (!article) return PHOTOS.messiCelebration;
  return article.cover_image || pickPhoto(article.id ?? article.title ?? "story");
}
